export enum AUDIO_NOTE_PENDING_SAVE_STEP {
    mediaDocSaved = 'mediaDocSaved',
    uploadComplete = 'uploadComplete',
}
